import React from 'react';
import { BetHistoryContainer, BetHistoryFilterTypes } from '@pascal/pascal-core';
import { BetHistoryItem } from './betHistoryItem';

export const BetHistoryWrapper = ({ isRepliedGame }) => {
  const { Win, Lose, All } = BetHistoryFilterTypes;
  return (
    <BetHistoryContainer
      isGetViaSocket
      filterNames={[All, ...(isRepliedGame ? [] : [Win, Lose])]}
      renderBetHistoryItem={(bet) => <BetHistoryItem bet={bet} key={JSON.stringify(bet)} />}
    />
  );
};
